


























































import { Component, Inject, Mixins } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import HasValidation from "@/mixins/HasValidation";
import Context from "@/mixins/context";

// Types
import {
  IBasketProviderMethods,
  IBasketProviderData
} from "@/models/providers/baskets";
import { IBasketPromotion } from "@/models/baskets";
import { AxiosError } from "axios";

@Component
export default class BasketPromos extends Mixins(Context, HasValidation) {
  // Inject - Basket provider

  @Inject({ from: "basketProviderData" })
  public readonly $basketData!: () => IBasketProviderData;

  @Inject({ from: "basketProviderMethods" })
  public readonly $basketMethods!: IBasketProviderMethods;

  // Variables

  public isProcessing: Record<string, boolean> = {};
  public code = "";

  // Computed

  public get basketData() {
    return this.$basketData();
  }

  public get mappedPromotions() {
    const nonAdjusted = _.filter(
      this.basketData.basket?.promotions || [],
      ({ promotion }) => !promotion?.adjusted_basket_id
    );
    return _.map(nonAdjusted, ({ id, promotion }) => ({
      id,
      coupon: promotion.code,
      tooltip:
        promotion.short_description_translated || promotion.short_description
    }));
  }

  public get isAdjustedBasket() {
    return _.some(
      this.basketData.basket?.promotions || [],
      ({ promotion }) => !!promotion.adjusted_basket_id
    );
  }

  public get isDisabled() {
    return (
      this.basketData.isProcessing ||
      this.basketData.isEmptyBasket ||
      this.isProcessing["apply"]
    );
  }

  // Methods

  public async removeCoupon(id: IBasketPromotion["id"]) {
    if (this.isProcessing[id]) return;
    this.$set(this.isProcessing, id, true);
    try {
      await this.$basketMethods.deletePromotion(id);
      await this.$basketMethods.refreshBasketData(true);
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.$delete(this.isProcessing, id);
    }
  }

  public async addPromotion() {
    if (!this.code.length || this.isProcessing["apply"]) return;

    this.$set(this.isProcessing, "apply", true);
    this.removeError("code");
    try {
      await this.$basketMethods.addPromotion(this.code);
      await this.$basketMethods.refreshBasketData();
      this.code = "";
    } catch (error) {
      if (
        this.$store.getters["api/is403"](error) ||
        this.$store.getters["api/is401"](error)
      ) {
        this.$basketMethods.forceBasketReset();
      }
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
      if (!this.hasError("code"))
        this.$set(this.validationErrors, "code", [
          (error as AxiosError)?.response?.data?.error?.message || ""
        ]);
    } finally {
      this.$delete(this.isProcessing, "apply");
    }
  }

  public async clearAdjustedTotal() {
    if (this.isProcessing.clear) return;
    try {
      this.$basketMethods.set("isProcessing", true);
      this.$set(this.isProcessing, "clear", true);

      const autoPromotionId = _.get(
        _.find(
          _.get(this.basketData, "basket.promotions", []),
          basketPromotion => !!basketPromotion.promotion.adjusted_basket_id
        ),
        "id"
      );

      await this.$basketMethods.deletePromotion(autoPromotionId);
      await this.$basketMethods.refreshBasketData(true);
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.$basketMethods.set("isProcessing", false);
      this.$delete(this.isProcessing, "clear");
    }
  }
}
